export default defineNuxtPlugin(() => {
  addRouteMiddleware(
    'auth-guard',
    (to, from) => {
      // console.log('global middleware AUTH GUARD')
    },
    { global: true },
  )
})
